import { Service, BaseService } from "@/core/auto";

@Service('/api/pasdphYoshin/')
export default class pasdehyoshin extends BaseService{
    send(data,t) {
		return this.request({
            showError: true,
            data: data,
			url: "/send",
			method: "POST",
			t
		})
	}
}